export const ru = {
  nav: {
    features: "Возможности",
    stats: "Статистика",
    pricing: "Тарифы",
    gallery: "Интерфейс",
    contacts: "Контакты",
    about: "О нас",
    faq: "FAQ",
    auth: "Авторизоваться",
    logout: "Выйти"
  },
  hero: {
    badge: "Версия 2.0.1.0 • Стабильный релиз",
    title: "Telegram PRIME",
    subtitle: "Универсальный автоматизированный комбайн для продвижения в Telegram. Мощные рассылки, инвайтинг, парсинг, чекеры и автоответчики в один клик.",
    ctaStart: "Начать бесплатно",
    ctaPricing: "Посмотреть тарифы",
    ctaInterface: "Обзор интерфейса"
  },
  stats: {
    title: "НАШЕ СООБЩЕСТВО и ДОСТИЖЕНИЯ!",
    onlineUsers: "Пользователей онлайн",
    
    reviews: "Отзывов на форумах",
    community: "Наше сообщество на форумах",
    invites: "Инвайтов за все время",
    messages: "Разослано сообщений"
  },
  features: {
    title: "ШИРОКИЙ ФУНКЦИОНАЛ КОМБАЙНА",
    subtitle: "Telegram PRIME содержит всё необходимое для комплексной работы и продвижения в мессенджере",
    showAll: "Показать все функции",
    hideAll: "Скрыть часть",
    items: {
      relogin: {
        title: "Релогин сессии",
        desc: "Позволит с легкостью использовать аккаунты одновременно подключаясь к ним из разных мест."
      },
      s2td: {
        title: "Конвертер Session - Tdata",
        desc: "Конвертируйте свои сессии в TData для использования на Telegram Desktop."
      },
      td2s: {
        title: "Конвертер Tdata - Session",
        desc: "Конвертируйте свои TData в сессии для использования в нашей программе."
      },
      warmup: {
        title: "Прогрев группы через ИИ",
        desc: "Запустите свои аккаунты в группу, задайте каждому партнера и тему для беседы, и получите живую группу."
      },
      vtope: {
        title: "Автоматизация vTope",
        desc: "Подключайтесь к наибольшей сети по накрутке vTope и зарабатывайте на просмотрах, реакциях и подписках."
      },
      automsg: {
        title: "Авто-написание вступившим",
        desc: "Используйте уникальнейшую возможность первым перехватить свежего клиента в чате."
      },
      autolike: {
        title: "Автореакции в канале",
        desc: "С этой функцией Вы всегда будете первым поставившим реакцию на новый пост."
      },
      autocomment: {
        title: "Автокомментарии в каналах",
        desc: "Как правило именно первые комментарии наиболее часто просматриваемые, так пусть он будет именно Ваш!"
      },
      checker: {
        title: "Чекер юзернеймов",
        desc: "Обрабатывайте свои базы логинов Телеграм быстро и легко для последующей работы с ними."
      },
      unblock: {
        title: "Снятие спамблока",
        desc: "Отправляйте запросы на снятие спамблока с уникальными причинами, продлевая жизнь аккаунтам."
      },
      admininvite: {
        title: "Инвайт через админку",
        desc: "Приглашайте пользователей в группы через назначенных админов, избегая банов самой группы."
      },
      reports: {
        title: "Массовые жалобы",
        desc: "Инструмент автоматической отсылки массовых жалоб на Telegram группы, каналы и боты."
      },
      randomizer: {
        title: "Рандомизатор текста 2.0",
        desc: "Когда спинтакс встречается с ИИ для достижения максимальной уникальности и качества контента."
      },
      stories: {
        title: "Работа с историями",
        desc: "Массовое создание историй на аккаунтах, просмотр историй и буст для ваших каналов."
      },
      interceptor: {
        title: "Перехватчик сообщений",
        desc: "Захватывайте и перенаправляйте входящие сообщения на лету в реальном времени в любое место."
      },
      chatcloner: {
        title: "Клонер чатов",
        desc: "Понравилась чужая группа? Сделайте себе точно такую же, включая оформление и пользователей."
      },
      webchat: {
        title: "Веб-развертка аккаунта",
        desc: "Больше нет необходимости переноса в tdata! Открывайте аккаунты в браузере в реальном времени."
      },
      offerphoto: {
        title: "Предложить фото юзеру",
        desc: "Позволяет массово предлагать фото пользователям, размещая на них свой рекламный оффер."
      },
      chancloner: {
        title: "Клонер каналов",
        desc: "Клонирование Telegram каналов в реальном времени (по мере выхода постов) или перенос старых постов."
      },
      autoinvite: {
        title: "Авто-инвайт новеньких",
        desc: "Следите за чужой группой и автоматически приглашайте всех новоприбывших в свой чат."
      }
    }
  },
  details: {
    sectionTitle: "ПОЧЕМУ TELEGRAM PRIME?",
    block1: {
      title: "Мощный инструмент маркетинга в Telegram",
      p1: "Присоединяйтесь к революции в мире цифрового продвижения уже сегодня!",
      p2: "Наш инструмент дает вам уникальную возможность доставлять ваши рекламные сообщения напрямую в телефоны ваших потенциальных клиентов, взаимодействуя с отдельными пользователями, мобильными номерами или всеми участниками Телеграм-групп.",
      p3: "У нас нет ограничений на креативность: поддерживаются все форматы оформления текста и отправка аудиофайлов в формате голосовых сообщений."
    },
    block2: {
      title: "Завоюйте мир быстрых и эффективных результатов!",
      p1: "Массовые рассылки в Телеграм - это самый громкий рупор продвижения. С Telegram PRIME вы можете осуществлять мощные рекламные кампании без больших затрат.",
      p2: "Программа предоставляет возможность целенаправленно фильтровать аудиторию, оставляя только живых и активных пользователей."
    },
    block3: {
      title: "Аналитика и сбор аудитории (Парсинг)",
      p1: "Собирайте целевую аудиторию из открытых и закрытых групп, комментариев на каналах и чатов.",
      p2: "Инновационный сбор по ключевым словам и детальная фильтрация по активности пользователя позволяют отсеять ботов."
    }
  },
  pricing: {
    title: "ТАРИФЫ И ИНСТРУМЕНТЫ",
    subtitle: "Выберите необходимые модули или дополнительные сервисы для вашего бизнеса",
    tabModules: "Модули программы",
    tabThirdParty: "Сторонний софт",
    tabPartners: "Услуги партнеров",
    buyCrypto: "Купить",
    askQuestion: "Задать Вопрос",
    eternal: "Вечный доступ",
    from: "от",
    modules: {
      cloner: {
        title: "КЛОНЕР КАНАЛОВ",
        price: "100 $",
        f1: "Вечный доступ - 100 $",
        f2: "Копирование чужих каналов",
        f3: "Фильтрация запрещенных слов",
        f4: "Замена ссылок на свои",
        f5: "Многопоточная работа"
      },
      interceptor: {
        title: "ПЕРЕХВАТЧИК СООБЩЕНИЙ",
        price: "100 $",
        f1: "Вечный доступ - 100 $",
        f2: "Слежка за активностью аккаунтов",
        f3: "Поиск ключевых слов в реальном времени",
        f4: "Пересылка заявок в ваш бот/канал",
        f5: "Настройка сложных фраз"
      },
      warmup: {
        title: "ПРОГРЕВАТОР АККАУНТОВ",
        price: "150 $",
        f1: "Вечный доступ - 150 $",
        f2: "Полная автоматизация диалогов",
        f3: "Прогрев через ИИ (ChatGPT)",
        f4: "Имитация живого общения в чатах",
        f5: "Настройка задержек и лимитов"
      }
    },
    thirdParty: {
      checker: {
        title: "Чекер телефонных номеров",
        price: "40 $",
        desc: "Проверка базы номеров на наличие Telegram с экспортом ID, Premium статуса и Username."
      },
      converters: {
        title: "Конвертеры аккаунтов",
        price: "29 $",
        desc: "Конвертация между Session, Tdata, AuthKey, JSON в любых направлениях с переавторизацией."
      },
      manager: {
        title: "Менеджер Web-Telegram",
        price: "40 $",
        desc: "Управление сеткой аккаунтов через браузер, планировщик задач, уникальные отпечатки сессий."
      }
    },
    partners: {
      vps: {
        title: "Cloud VPS Серверы",
        price: "14 $ / мес",
        desc: "Анонимные Windows/Linux VPS, идеально совместимые и настроенные под работу с TG Prime."
      },
      redirect: {
        title: "Stealth Redirect ссылки",
        price: "15 $ / мес",
        desc: "Сервис сокращения и маскировки ссылок с защитой от банов, подключением доменов и аналитикой."
      },
      proxies: {
        title: "Приватные Прокси",
        price: "7.5 $ / мес",
        desc: "Мобильные и резидентские SOCKS5/HTTP прокси со сменой IP по таймеру или ссылке."
      }
    }
  },
  about: {
    title: "О НАС",
    subtitle: "Команда, которая делает автоматизацию Telegram доступной и эффективной",
    lead: "Telegram PRIME - это официальная платформа для продажи лицензионных ключей Telegram Prime и модулей расширения.",
    story: "Мы работаем с маркетингом в Telegram более 5 лет и объединили весь необходимый инструментарий в одном экосистемном решении. Наша цель - дать арбитражникам, SMM-специалистам и владельцам бизнеса надёжный софт, прозрачные цены и оперативную поддержку. Каждый ключ активируется в личном кабинете, а обновления выходят регулярно и бесплатно для всех пользователей.",
    value1: {
      title: "Официальные ключи",
      desc: "Покупайте лицензии Telegram Prime напрямую через защищённый личный кабинет без посредников и переплат."
    },
    value2: {
      title: "Поддержка 24/7",
      desc: "Наша команда помогает с активацией, настройкой модулей и HWID-привязкой в Telegram и через тикет-систему."
    },
    value3: {
      title: "Регулярные обновления",
      desc: "Telegram постоянно меняется, поэтому мы выпускаем обновления и фиксы для стабильной работы всех функций."
    },
    value4: {
      title: "Сообщество профессионалов",
      desc: "Присоединяйтесь к чату пользователей, где делятся кейсами, новыми схемами и помощью по работе с софтом."
    },
    tag: "Официальный реселлер",
    stat1: { label: "Лет на рынке" },
    stat2: { label: "Модулей" },
    stat3: { label: "Поддержка" },
    ctaTitle: "Остались вопросы?",
    ctaText: "Напишите нам на email - поможем с выбором модуля, активацией и настройкой.",
    ctaButton: "Email"
  },
  faq: {
    title: "ЧАСТЫЕ ВОПРОСЫ",
    subtitle: "Ответы на самые популярные вопросы о покупке, активации и работе Telegram Prime",
    q1: "Что такое Telegram Prime и зачем нужен ключ?",
    a1: "Telegram Prime - это комплексное ПО для автоматизации продвижения в Telegram: рассылки, инвайтинг, парсинг, клонирование и многое другое. Лицензионный ключ открывает доступ к личному кабинету и выбранным модулям.",
    q2: "Как купить ключ Telegram Prime?",
    a2: "Выберите подходящий тариф или модуль, нажмите «Купить» и оплатите криптовалютой. После подтверждения оплаты ключ сразу появится в вашем личном кабинете.",
    q3: "В чём разница между демо, месячным и вечным ключом?",
    a3: "Демо-ключ выдаётся на 3 дня и подходит для тестирования. Месячный ключ работает 30 дней. Вечный ключ даёт пожизненный доступ к базовой лицензии и бесплатным обновлениям.",
    q4: "Что делать, если сменился компьютер или железо?",
    a4: "В личном кабинете доступен сброс HWID-привязки. Он позволяет перенести активированный ключ на новый ПК. Для демо-ключа сброс недоступен.",
    q5: "Можно ли добавить модули после покупки ключа?",
    a5: "Да, любой модуль можно докупить отдельно в личном кабинете. Он сразу привяжется к вашему текущему ключу и активируется автоматически.",
    q6: "Какие способы оплаты доступны?",
    a6: "Мы принимаем только криптовалюту. Реквизиты для оплаты отображаются при оформлении покупки в личном кабинете.",
    q7: "Есть ли возврат средств после покупки ключа?",
    a7: "Цифровые ключи и модули возврату не подлежат, если они уже были активированы. До покупки рекомендуем использовать бесплатный демо-период.",
    q8: "Куда обращаться за помощью?",
    a8: "Напишите нам в онлайн-чат - среднее время ответа от нескольких минут до пары часов.",
    q9: "Можно ли купить модуль отдельно от ядра программы?",
    a9: "Да, любой модуль можно приобрести отдельно. Вам не обязательно покупать базовую лицензию, если нужен только конкретный функционал. Модуль активируется в личном кабинете и привязывается к вашему HWID."
  },
  auth: {
    login: "Войти",
    register: "Регистрация",
    email: "Email адрес",
    password: "Пароль",
    username: "Имя пользователя",
    confirmPassword: "Подтвердите пароль",
    submitLogin: "Авторизоваться",
    submitRegister: "Создать аккаунт",
    noAccount: "Еще нет аккаунта?",
    haveAccount: "Уже есть аккаунт?",
    title: "Личный кабинет Telegram Prime",
    close: "Закрыть",
    successMsg: "Вы успешно авторизовались!",
    welcome: "Добро пожаловать в панель управления!",
    captchaRequired: "Пожалуйста, подтвердите, что вы не робот.",
    or: "или",
    googleLogin: "Войти через Google",
    fillAllFields: "Пожалуйста, заполните все поля.",
    passwordMismatch: "Пароли не совпадают!",
    passwordWeak: "Пароль слишком простой!",
    registerSuccess: "Регистрация успешна! Пожалуйста, войдите в аккаунт.",
    passwordStrengthWeak: "Слабый",
    passwordStrengthMedium: "Средний",
    passwordStrengthStrong: "Надёжный",
    errorUnknown: "Произошла ошибка",
    verifyTitle: "Подтверждение почты",
    verifyIntro: "Мы отправили 6-значный код на {email}. Введите его, чтобы завершить регистрацию. Аккаунт создаётся только после подтверждения.",
    verifyLoginTitle: "Подтверждение входа",
    verifyLoginIntro: "Обнаружен вход с нового IP-адреса. Мы отправили код на {email}. Введите его, чтобы подтвердить вход.",
    codeLabel: "Код подтверждения",
    codePlaceholder: "6-значный код",
    confirmCode: "Подтвердить",
    resendCode: "Отправить код повторно",
    resendIn: "Отправить повторно через {seconds} с",
    changeEmail: "Назад",
    codeRequired: "Введите код подтверждения.",
    devCodeNotice: "Режим разработки (отправка писем выключена), ваш код: {code}"
  },
  gallery: {
    title: "УДОБНЫЙ ИНТЕРФЕЙС ПРОГРАММЫ",
    subtitle: "Скриншоты рабочей панели управления и модулей Telegram PRIME"
  },
  footer: {
    desc: "Telegram PRIME - профессиональное ПО для лидогенерации и автоматизации в мессенджере Telegram. Все права защищены.",
    community: "Присоединяйтесь к сообществу",
    support: "Техническая поддержка работает Пн-Пт 08:00 - 20:00 (GMT+2)."
  },
  // Добавь внутрь экспортируемого объекта ru:
  dashboard: {
    download: "Скачать Telegram Prime",
    title: "ПАРАМЕТРЫ СИСТЕМЫ",
    modulesTitle: "УПРАВЛЕНИЕ СБОРКОЙ",
    newsTitle: "БОРТОВОЙ ЖУРНАЛ",
    license: "Моя лицензия",
    shop: "Витрина модулей",
    changelog: "Бортовой журнал",
    referral: "Реферальная система",
    faq: "Вопросы и ответы",
    keyInfo: "Лицензионный Ключ",
    activated: "АКТИВИРОВАН",
    notActivated: "НЕ АКТИВИРОВАН",
    hwidLinked: "Привязан к ПК",
    hwidFree: "Свободен / Сброшен",
    resetHwid: "Сбросить привязку (HWID Reset)",
    activatePc: "Активировать на этом ПК",
    activeComponents: "Активные компоненты",
    installed: "Приобретён",
    buy: "Купить",
    select: "Выбрать",
    free: "Бесплатно",
    activateFree: "Активировать бесплатно",
    linkKeyFirst: "Ошибка! Сначала привяжите ключ.",
    selectLicensePlan: "Выберите тарифный план для генерации лицензионного ключа:",
    demoPeriod: "На 3 дня",
    monthlyPeriod: "На 30 дней",
    permanentPeriod: "Навсегда",
    payWithCrypto: "ОПЛАТИТЬ КРИПТОЙ",
    transaction: "ЗАПРОС НА ТРАНЗАКЦИЮ",
    selectLicenseType: "Выберите тип лицензии",
    billingFor: "Шлюз оплаты для:",
    abort: "Прервать операцию",
    blocked: "ЗАБЛОКИРОВАНА",
    expired: "ИСТЕКЛА",
    licenseKey: "Лицензионный Ключ",
    licenseType: "Тип",
    expiresAt: "Истекает",
    activeModulesCount: "Активных модулей",
    active: "Активных",
    lifetime: "Вечный",
    deleteKey: "Удалить ключ",
    upgradeToPermanent: "Апгрейд до вечного",
    upgradeToMonthly: "Апгрейд до месячного",
    extendLicense: "Продлить лицензию",
    licenseBlockedContactSupport: "Лицензия заблокирована. Обратитесь в поддержку.",
    noLicenseMessage: "У вас пока нет активной лицензии. Выберите тарифный план, чтобы начать работу.",
    buyLicenseOrDemo: "Купить лицензию / Взять Демо",
    ready: "ГОТОВ",
    noActiveModules: "Нет активных модулей",
    copyKey: "Скопировать ключ",
    copied: "Скопировано!",
    referralTitle: "Реферальная система",
    referralCode: "Ваш реферальный код",
    referralBalance: "Реферальный баланс",
    referralHowItWorks: "Как это работает:",
    referralStep1: "Скопируйте ваш персональный код.",
    referralStep2: "Поделитесь кодом с другом или в рекламе.",
    referralStep2Link: "Делитесь реферальной ссылкой — все переходы по ней считаются автоматически.",
    referralStep3: "Покупатель получает скидку {percent}% на платный ключ.",
    referralStep4: "Вы получаете {percent}% от покупки на баланс.",
    referralDemoInfo: "Скидка {percent}% применяется только к платным ключам. Для демо-ключа реферальный код недоступен.",
    referralLinkLabel: "Ваша реферальная ссылка",
    referralLinkCopied: "Реферальная ссылка скопирована!",
    referralLinkHint: "Каждый, кто перейдёт по этой ссылке, автоматически получит ваш реферальный код — промокод вводить не нужно.",
    referralClicks: "Переходы по ссылке",
    faqTitle: "Частые вопросы",
    faqEmpty: "Вопросы и ответы временно недоступны.",
    referralTagline: "Зарабатывайте вместе с Telegram Prime ❤️",
    applyReferralCode: "Применить реферальный код",
    referralCodePlaceholder: "Введите реферальный код",
    referralHint: "Введите реферальный код перед покупкой, чтобы получить скидку на платный ключ.",
    apply: "Применить",
    referralCodeApplied: "Реферальный код применён - скидка {percent}%",
    referralCodeInvalid: "Реферальный код недействителен",
    referralCodeCopied: "Реферальный код скопирован!",
    applyPromoCode: "У меня есть промокод",
    promoCodePlaceholder: "Введите промокод",
    promoHint: "Введите промокод перед покупкой, чтобы получить дополнительную скидку. Скидки по промокоду и реферальному коду суммируются.",
    promoCodeApplied: "Промокод применён - скидка {percent}%",
    promoCodeInvalid: "Промокод не найден или не активен",
    referralTransactions: "Реферальные начисления",
    referralEarning: "Начисление",
    referralNoTransactions: "Пока нет реферальных начислений.",
    messages: {
      demoResetDisabled: "Сброс HWID недоступен для демо-ключа",
      keyNotBound: "Ключ не привязан к устройству",
      licenseExpired: "Лицензия истекла. Сначала продлите ее.",
      licenseBlocked: "Лицензия заблокирована",
      hwidResetSuccess: "Привязка HWID успешно сброшена!",
      tooManyRequests: "Слишком много запросов. Подождите 24 часа.",
      hwidResetFailed: "Не удалось сбросить HWID",
      networkError: "Ошибка сети",
      confirmDeleteKey: "Вы уверены, что хотите удалить ключ? Это действие нельзя отменить.",
      keyDeletedSuccess: "Ключ успешно удален!",
      keyDeleteFailed: "Не удалось удалить ключ",
      redirectingToPayment: "Перенаправление на оплату...",
      upgradeRequestSent: "Запрос на апгрейд отправлен!",
      upgradeRequestFailed: "Не удалось отправить запрос на апгрейд",
      extensionRequestSent: "Запрос на продление отправлен!",
      extensionRequestFailed: "Не удалось отправить запрос на продление",
      demoModulesAdded: "Модули бесплатно добавлены на демо-ключ",
      demoModulesFailed: "Не удалось добавить модули на демо-ключ",
      copyKeySuccess: "Ключ скопирован в буфер обмена",
      copyKeyFailed: "Не удалось скопировать ключ"
    }
  },
  license: {
    success: {
      demo_activated: "Демо-ключ успешно активирован"
    }
  },
  cabinetFaq: {
    subtitle: "Частые вопросы и ответы по работе с лицензией и модулями",
    q1: "Как активировать купленный ключ?",
    a1: "После оплаты ключ появится в вашем личном кабинете на вкладке «Моя лицензия». Нажмите «Активировать на этом ПК», чтобы привязать HWID.",
    q2: "Что такое HWID и зачем он нужен?",
    a2: "HWID - это уникальный идентификатор вашего компьютера. Он защищает ключ от передачи третьим лицам. Привязка осуществляется автоматически при активации.",
    q3: "Как сбросить HWID, если я сменил компьютер?",
    a3: "В личном кабинете на вкладке «Моя лицензия» нажмите «Сбросить привязку (HWID Reset)». Сброс доступен не чаще раз в 24 часа. Для демо-ключа сброс недоступен.",
    q4: "Как купить дополнительный модуль?",
    a4: "Перейдите на вкладку «Витрина модулей», выберите нужный модуль и нажмите «Купить». После оплаты модуль автоматически привяжется к вашему ключу.",
    q5: "Можно ли использовать один ключ на нескольких ПК?",
    a5: "Нет, один ключ может быть активирован только на одном ПК одновременно. Для переноса используйте сброс HWID.",
    q6: "Где скачать Telegram Prime?",
    a6: "Ссылка для скачивания находится в верхней части личного кабинета - кнопка «Скачать Telegram Prime».",
    q7: "Как применить реферальный код?",
    a7: "В личном кабинете есть блок «Реферальная система». Введите код в поле перед покупкой платного ключа, и скидка автоматически применится.",
    q8: "Что делать, если лицензия истекла?",
    a8: "На вкладке «Моя лицензия» выберите «Продлить лицензию» или «Апгрейд до вечного». После оплаты доступ восстановится.",
    q9: "Что делать, если ключ заблокирован?",
    a9: "Если вы видите статус «Заблокирована», обратитесь в техническую поддержку. Блокировка может быть связана с нарушением правил использования.",
    q10: "Почему модуль не появился после оплаты?",
    a10: "Проверьте статус платежа в личном кабинете. Если деньги списаны, но модуль не добавлен, обратитесь в поддержку с номером транзакции.",
    supportTitle: "Не нашли ответ?",
    supportText: "Напишите нам в онлайн-чат - поможем разобраться с активацией, модулями и оплатой.",
    emailBtn: "Email",
    telegramBtn: "Telegram"
  },
  modules: {
    module_1: {
      name: "Клонер чатов",
      features: [
        "Вечный доступ - 345 $",
        "Сбор истории чатов",
        "Подготовка аккаунтов",
        "Редактор сообщений, редактируйте историю, как вам нужно",
        "Постинг истории за интервалами или как в оригинале",
        "Получаете копию группы конкурента",
        "Возврат средств не предусмотрен"
      ]
    },
    module_2: {
      name: "Репортер",
      features: [
        "Вечный доступ - 175 $",
        "Возможность заблокировать канал конкурента",
        "Возможность заблокировать группу конкурентов",
        "Возможность заблокировать бота ТГ",
        "Жалобы через инвайтинг в чаты",
        "Многопоточная работа",
        "Возврат средств не предусмотрен"
      ]
    },
    module_3: {
      name: "Клонер каналов",
      features: [
        "Вечный доступ - 105 $",
        "Автономное наполнение каналов",
        "Замена ключевых слов и ссылок",
        "Клонер старых постов",
        "Исключение нежелательного контента и добавление своего",
        "Многопоточная работа для получения быстрых результатов",
        "Возврат средств не предусмотрен"
      ]
    },
    module_4: {
      name: "Перехватчик сообщений",
      features: [
        "Вечный доступ - 100 $",
        "Следит за всем, что происходит на аккаунте",
        "Поиск ключевых слов в чатах в реальном времени",
        "Многопоточная работа",
        "Пересылайте заявки куда вам нужно (канал, бот или аккаунт)",
        "Используйте ключевые слова или фразы",
        "Возврат средств не предусмотрен"
      ]
    },
    module_5: {
      name: "Прогреватор аккаунтов",
      features: [
        "Вечный доступ - 150 $",
        "Полностью автоматизированная работа модуля",
        "Прогрев через множество автоматически выполняемых действий",
        "Управление количеством выполняемых задач",
        "Уникализация текста через ИИ",
        "Многопоточная работа с настройкой задержек между действиями",
        "Возврат средств не предусмотрен"
      ]
    }
  },
  news: {
    error: "Не удалось загрузить обновления",
    noUpdates: "Нет доступных обновлений",
    loading: "Загрузка обновлений...",
    latestUpdate: "ПОСЛЕДНЕЕ ОБНОВЛЕНИЕ",
    version: "ВЕРСИЯ",
    update: "ОБНОВЛЕНИЕ"
  }
};
